/*  global _ */
import {Vue} from '~/addiesaas'

import {mapGetters, mapActions} from 'vuex'
import config from '../../../lib/config'
const {BASE_IMAGES: reImagePath} = config

import CheckoutMixin from '../../../components/_mixins/location-checkout'
import PageMixin from '../../../components/_mixins/pages'

const EventBus = window.VueEventBus

const routes = window.addiesaas.routes || []

// @todo: get the defaults from backend config or fallback to this defaults
const defaults = {
  noHeaders: true,
  noPaymentMethodsInfo: false,
  noActions: false,
  headers: ['Item', 'Quantity', 'Price'],
  paymentMethods: {
    message: null,
    items: {
      'visa': {
        'image': `${reImagePath}payment-card-visa.png`,
        'title': 'Visa',
        'url': '//usa.visa.com/',
        'cssClass': [],
      },
      'mastercard': {
        'image': `${reImagePath}payment-card-master.png`,
        'title': 'Mastercard',
        'url': '//www.mastercard.us/',
        'cssClass': [],
      },
      'americanexpress': {
        'image': `${reImagePath}payment-card-ae.png`,
        'title': 'American Express',
        'url': '//www.americanexpress.com/',
        'cssClass': [],
      },
      'discover': {
        'image': `${reImagePath}payment-card-discover.png`,
        'title': 'Discover',
        'url': '//www.discover.com/',
        'cssClass': [],
      },
    }
  },
  actionButtons: {
    edit: {
      text: '',
      title: 'Edit',
      // image: `${reImagePath}/images/movie-bowl-grille/icons/edit-icon.svg`,
      cssClass: [],
      displayable: (item) => item.editable,
      onClick: (args) => {
      },
    },
    delete: {
      text: '',
      title: 'Delete',
      // image: `${reImagePath}/images/movie-bowl-grille/icons/close-icon.svg`,
      cssClass: [],
      displayable: (item) => item.deletable,
      onClick: (args) => {
      }
    },
  },
  costDetailsInfo: {
    price: {
      'label': 'Sub total:',
      'prefix': '$',
      'suffix': ''
    },
    tax: {
      'label': 'Taxes:',
      'prefix': '$',
      'suffix': ''
    },
    deduct: {
      'label': 'Discount total:',
      'prefix': '$',
      'suffix': ''
    },
    total: {
      'label': 'Total:',
      'prefix': '$',
      'suffix': ''
    },
  },
  costDetailsOrder: ['price', 'tax', 'deduct', 'total'],
  submitButton: {
    text: 'Submit',
    includeAmount: true,
    title: 'Proceed to payment',
    containerClass: [],
    cssClass: ['btn', 'btn-next', 'btn-accent'],
    onClick: (args) => {
    },
  },
  errorContainerClass: [],
  loginUri: routes.find(x => x.name == 'sign-in')?.path || '/sign-in',
  loginText: 'Sign In',
  registerUri: routes.find(x => x.name == 'user.register')?.path || '/register',
  registerText: 'Register',
  itemComponentPrefix: '',
  itemComponentSuffix: '-cart-item',

  productGroupNames: {
    reservation: 'Party Booking',
    movie: 'Movie Tickets',
  }
}

export default {
  name: 'shopping-cart',
  settings: 'page.cart',
  translations: 'page.cart',
  props: {
    noHeaders: {
      default: defaults.noHeaders
    },
    noPaymentMethodsInfo: {
      default: defaults.noPaymentMethodsInfo
    },
    noActions: {
      default: defaults.noActions
    },
    headers: {
      default: () => defaults.headers
    },
    paymentMethods: {
      default: () => defaults.paymentMethods
    },
    actionButtons: {
      default: () => ({})
    },
    costDetailsInfo: {
      default: () => ({})
    },
    costDetailsOrder: {
      default: () => defaults.costDetailsOrder
    },
    submitButton: {
      default: () => defaults.submitButton
    },
    errorContainerClass: {
      default: () => defaults.errorContainerClass
    },
    loginUri: {
      default: defaults.loginUri
    },
    loginText: {
      default: defaults.loginText
    },
    registerUri: {
      default: defaults.registerUri
    },
    registerText: {
      default: defaults.registerText
    },
    cartComponentPrefix: {
      default: ''
    },
    cartComponentSuffix: {
      default: ''
    },
    itemComponentPrefix: {
      default: defaults.itemComponentPrefix
    },
    itemComponentSuffix: {
      default: defaults.itemComponentSuffix
    },
    useDefaultItemViewer: {
      default: false
    },
    orderItemsByGroup: {
      default: true
    },
    showGroupTitle: {
      default: true
    },
    noAuthCheck: {
      default: true
    }
  },
  mixins: [CheckoutMixin, PageMixin],
  data: () => ({
    isValidating: false,
    //costDetails: null,
    //valid: false,
    //validationError: null,
    //askToSignIn: false,
    errors: {},
    itemErrors: {},
    validationCanceller: null,
  }),

  computed: {
    me() {
      return this
    },
    ...mapGetters({
      authenticated: 'authCheck',
    }),
    cartHeaders() {
      return this.headers || []
    },
    cartPaymentMethods() {
      return this.paymentMethods || {message: '', items: {}}
    },
    cartActionButtons() {
      return _.merge({}, defaults.actionButtons, this.actionButtons || {})
    },
    cartCostDetails() {
      const info = _.merge({}, defaults.costDetailsInfo, this.costDetailsInfo || {})
      const sortOrder = this.costDetailsOrder || []
      const raw = this.costDetails || {}
      return sortOrder.reduce(
        (details, key) => info[key] && !_.isNil(raw[key]) ? [...details, {
          ...info[key], ...{
            key,
            value: raw[key]
          }
        }] : details
        , [])
    },
    cartItemsOrderedByType() {

      if (!this.orderItemsByGroup) {
        return {all: this.currentCartItems}
      }

      let items = {}
      _.forOwn(this.currentCartItems, (item, id) => {
        const group = item.type
        // console.log(group)
        items[group] = items[group] || {}
        items[group][id] = item
      })
      // console.log(items)
      return items
    },

    hasRedemptionErrors() {
      return !_.isEmpty(this.redemptionErrors)
    },
    couponDiscountErrors() {
      const allItems = this.redemptionErrors.discounts
      const items = _.pickBy(allItems, item => item.type === 'coupon')
      return _.isEmpty(items) ? null : items
    },
    redemptionErrors() {
      const validationErrors = this.validationErrors
      if (validationErrors) {
        const errorMessages = _.reduce(validationErrors.errors, (carry, item, path) => {
          _.set(carry, path, item)
          return carry
        }, {})

        const discounts = _.cloneDeep(_.values(this.cartDiscounts))
        const errors = _.mapValues(errorMessages, details => {
          return _.mapValues(details, (error, index) => {
            return {
              ...(discounts[index] || {}),
              error,
            }
          })
        })
        return _.pick(errors, ['discounts'])
      }
      return {}
    }
  },

  async created() {
    EventBus.$on('cart.validate', async () => {
      await this.validateCart()
    })
    EventBus.$on('cart.validate', () => {
      this.isValidating++
    })
    EventBus.$on('cart.error', x => {
      this.isValidating = 0
    })
    EventBus.$on('cart.validated', x => {
      this.isValidating--
      if (this.isValidating < 0) {
        this.isValidating = 0
      }
    })
    EventBus.$on('cart.validating', (validating) => {
      this.isValidating += validating ? +1 : -1
      if (this.isValidating < 0) {
        this.isValidating = 0
      }
    })

    EventBus.$on('user.logout', async () => {
      EventBus.$emit('cart.validate')
    })

    EventBus.$on('cart-item-deleted', _.debounce(async () => {
      EventBus.$emit('cart.validate')
    }, 500,{leading: false, trailing: true}))

    EventBus.$emit('cart.validate')
  },
  watch: {

  },
  methods: {
    ...mapActions(['rememberAfterLoginRoute']),
    cancelValidation(msg) {
      if (this.isValidating) {
        if (this.validationCanceller && this.validationCanceller.cancel) {
          this.validationCanceller.cancel(msg)
          return true
        }
      }
    },

    getViewerComponent(type, suffix = '', prefix = '') {
      if (!this.useDefaultItemViewer) {
        const componentName = (prefix || '') + _.kebabCase(type || '') + (suffix || '')
        if (componentName in Vue.options.components || componentName in this.$options.components) {
          return componentName
        }
      }
      return null
    },
    getSummaryTotal() {
      const summary = this.costDetails || {}
      return '$' + (summary.total || 0).toFixed(2)
    },
    getSubmitButtonText() {
      return this.submitButton.text +
        (this.submitButton.includeAmount ? (' ' + this.getSummaryTotal()) : '')
    },
    // movie-cart-item // reservation-cart-item
    getCartItemViewer(item, suffix = '', prefix = '') {
      if (!this.useDefaultItemViewer) {
        const componentName = item.ComponentName ||
          _.kebabCase(_.filter([
            item.componentPrefix,
            prefix || this.itemComponentPrefix,
            item.type,
            item.componentSuffix,
            suffix || this.itemComponentSuffix
          ]).join(''))

        if (componentName in Vue.options.components || componentName in this.$options.components) {
          return componentName
        }
      }
      return null
    },
    getGroupTitle(group, items) {
      return defaults.productGroupNames[group] || ((Object.values(items)[0] || {}).groupTitle || '')
    },
    cartSubmitButtonClicked($event) {
      const args = {$event, items: this.currentCartItems, cart: this}
      let nativeMethodCall = true
      if (this.submitButton.onClick) {
        nativeMethodCall = this.submitButton.onClick(args) !== false
      }

      nativeMethodCall = EventBus.$emit('cart.process', args) !== false

      if (nativeMethodCall) {
        this.$emit('proceed')
      }
    },
    cartItemButtonClicked(args) {

      args['cart'] = this
      const {actionName, item, button} = args
      const onActionName = _.camelCase(`on-${actionName}`)
      const methodName = _.camelCase(`cart-item-${onActionName}`)
      const eventName = _.kebabCase(`cart-item-before-${actionName}`)

      let nativeMethodCall = true

      if (item[onActionName]) {
        nativeMethodCall = item[onActionName](args) !== false
      }

      if (button[onActionName]) {
        nativeMethodCall = button[onActionName](args) !== false
      }

      nativeMethodCall = this.$emit(eventName, args) !== false
      nativeMethodCall = EventBus.$emit(eventName, args) !== false

      if (nativeMethodCall) {
        if (this[methodName]) {
          this[methodName](args)
        }
      }

    },
    cartItemOnEdit(args) {

      const {item} = args

      const eventName = 'cart-item-edited'
      this.$emit(eventName, args)
      EventBus.$emit(eventName, args)

      if (item.editRoute) {
        const route = Object.assign({}, item.editRoute, {query: {token: item.id}})
        this.$router.push(route)
      }
    },

    /**
     *
     * @param item Object must have `id` property which refers to the item.id
     */
    cartItemOnDelete(args) {
      const {item} = args

      this.removeCartItem(item)

      const eventName = 'cart-item-deleted'
      this.$emit(eventName, args)
      EventBus.$emit(eventName, args)
    },

    storeAfterLoginRedirect() {
      this.setPostLoginPage('page-checkout')
      this.rememberAfterLoginRoute({ route: 'racewaybooking.checkout', expires: 1 })
    },

    getCouponDiscountErrorMessage(discount) {
      discount.code = _.get(discount, 'payload.options.code')
      discount.message = _.get(discount, 'error.code').join(', ')
      return `An error occurred with coupon - ${discount.code}. ${discount.message}. But you can still complete your order without discount.`
    },
    async removeCouponDiscount(coupon) {
      this.removeCartDiscount(coupon)
      await this.validateCart(true)
    },
  }
}
